import gql from 'graphql-tag'

export const queryCampaignByPk = campaignId => {
	return {
		query: gql`
			query ($campaign_id: bigint!) {
				conf_campaigns_by_pk(id: $campaign_id) {
					name
					country_id
				}
			}
		`,
		update(data) {
			return {
				name: data.conf_campaigns_by_pk.name,
				countryId: data.conf_campaigns_by_pk.country_id
			}
		},
		variables: {
			campaign_id: campaignId
		}
	}
}
